import { useQuery } from "@tanstack/react-query";

import { getMultiPlatformPlatformByPlatformIdLocationCoordinates } from "@/api/methods";
import { requestGuestPosition } from "@/modules/anonymousBrowsing/requestGuestPosition";

import { suggestSignUpLocation } from "./suggestSignUpLocation";

export const useSignUpLocationSuggestion = (platformId: string, enabled: boolean) =>
  useQuery({
    queryKey: ["signUpLocationSuggestion", platformId],
    queryFn: async () => {
      // Keep the patient's coordinates inside this calculation; only the suggested branch is cached.
      const [coordinates, position] = await Promise.all([
        getMultiPlatformPlatformByPlatformIdLocationCoordinates({ platformId }),
        requestGuestPosition(),
      ]);
      return suggestSignUpLocation(coordinates, position);
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    cacheTime: 0,
    useErrorBoundary: false,
  });
